/* Shared storefront catalog results for the guided finder and gift budget. */
(() => {
  'use strict';
  const requests = new WeakMap();
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  function budgetValue(value) {
    // Older callers used 12000 as the label for an unrestricted selection.
    return value === 'all' || String(value) === '12000' ? 'all' : ['2500','5000'].includes(String(value)) ? String(value) : '2500';
  }
  function catalogUrl(base, budget) {
    const url = new URL(base, location.origin);
    if (url.origin !== location.origin || !/\/collections\//.test(url.pathname)) throw Error('Invalid collection');
    ['page','view','filter.v.price.gte','filter.v.price.lte'].forEach(key => url.searchParams.delete(key));
    const chosen = budgetValue(budget);
    if (chosen !== 'all') url.searchParams.set('filter.v.price.lte', chosen);
    url.searchParams.set('filter.v.availability', '1');
    if (window.DS_CRO?.preview && window.DS_CRO.themeId) url.searchParams.set('preview_theme_id', window.DS_CRO.themeId);
    url.hash = '';
    return url.pathname + url.search;
  }
  function safeLink(value, kind) {
    try {
      const url = new URL(value, location.origin);
      if (!/^https?:$/.test(url.protocol)) return '';
      if (kind === 'product' && (url.origin !== location.origin || !/\/products\//.test(url.pathname))) return '';
      if (kind === 'product' && window.DS_CRO?.preview && window.DS_CRO.themeId) url.searchParams.set('preview_theme_id', window.DS_CRO.themeId);
      return url.href;
    } catch { return ''; }
  }
  function cardsFromDocument(doc, budget) {
    const limit = budgetValue(budget) === 'all' ? Infinity : Number(budgetValue(budget)) * 100;
    return [...doc.querySelectorAll('[data-dsc-card]')].map(card => {
      const anchor = card.querySelector('.dsc-card__title-row a'), image = card.querySelector('img'), price = card.querySelector('[data-dsc-prices] strong');
      let product;
      try { product = JSON.parse(card.querySelector('[data-dsc-product]')?.textContent || 'null'); } catch { return null; }
      if (!product || product.available !== true || !Number.isSafeInteger(product.price) || product.price < 0 || product.price > limit) return null;
      const href = anchor && safeLink(anchor.getAttribute('href'), 'product');
      if (!href || !price) return null;
      return {href, title:anchor.textContent.trim(), price:price.textContent.trim(), image:image && safeLink(image.getAttribute('src'), 'image')};
    }).filter(Boolean).slice(0, 3);
  }
  function cardMarkup(card, kind) {
    const photo = card.image ? '<img src="' + escape(card.image) + '" alt="' + escape(card.title) + '" loading="lazy" width="140" height="140">' : '';
    return '<a class="' + (kind === 'gifts' ? 'boutique-pick' : 'result-card') + '" href="' + escape(card.href) + '">' + photo + '<span><strong>' + escape(card.title) + '</strong><b>' + escape(card.price) + '</b></span><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 12h15M14 7l5 5-5 5"/></svg></a>';
  }
  async function load(target, options) {
    if (!target) return;
    requests.get(target)?.abort();
    const controller = new AbortController();
    requests.set(target, controller);
    const timer = setTimeout(() => controller.abort(), 12000);
    const current = () => requests.get(target) === controller && target.isConnected && (!target.closest('dialog') || target.closest('dialog').open);
    target.setAttribute('aria-busy', 'true');
    target.innerHTML = '<p>Finding pieces in your budget…</p>';
    let status = 'error', resultCount = 0;
    try {
      const response = await fetch(options.url, {credentials:'same-origin', signal:controller.signal, headers:{Accept:'text/html'}});
      if (!response.ok) throw Error('Catalog unavailable');
      if (response.url && new URL(response.url, location.origin).origin !== location.origin) throw Error('Invalid catalog response');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!current()) return;
      if (!doc.querySelector('[data-dsc-grid]')) throw Error('Catalog unavailable');
      const cards = cardsFromDocument(doc, options.budget);
      resultCount = cards.length;
      status = resultCount ? 'success' : 'empty';
      target.innerHTML = cards.map(card => cardMarkup(card, options.kind)).join('') || '<p>No available pieces match this selection. Try another budget or ask the studio for help.</p>';
    } catch {
      if (!current()) return;
      target.innerHTML = '<p>We could not load these suggestions. Open the matching collection below to continue with your selected budget.</p>';
    } finally {
      clearTimeout(timer);
      if (current()) {
        requests.delete(target);
        target.removeAttribute('aria-busy');
        if (options.kind !== 'gifts') document.dispatchEvent(new CustomEvent('ds:finder-results', {detail:{source:options.source, status, resultCount, budget:budgetValue(options.budget), category:options.category || '', shape:options.shape || ''}}));
      }
    }
  }
  function loadGifts() {
    const control = document.getElementById('gift-budget'), target = document.getElementById('gift-picks');
    if (!control || !target) return;
    const root = window.Shopify?.routes?.root || '/';
    const url = catalogUrl(root.replace(/\/?$/, '/') + 'collections/all', control.value);
    const link = document.getElementById('gift-budget-matches');
    if (link) link.href = url;
    return load(target, {url,kind:'gifts',budget:control.value});
  }
  window.DSCatalogDiscovery = {budgetValue,catalogUrl,load,loadGifts};
})();
